/* XYRA Fluid 3.0 - native forms first; JS progressively adds galleries and the cart drawer. */
(() => {
  'use strict';
  const configNode = document.getElementById('XyraConfig');
  if (!configNode) return;
  let config;
  try { config = JSON.parse(configNode.textContent); } catch (error) { console.error('XYRA configuration:', error); return; }
  const messages = config.messages;
  const initializedProducts = new WeakSet();
  const initializedGalleries = new WeakSet();
  let cartBusy = false;
  let cartReturnFocus = null;
  const api = route => route.endsWith('.js') ? route : `${route}.js`;
  const announce = text => { const node = document.getElementById('XyraStatus'); if (node) node.textContent = text; };
  const decodeText = text => new DOMParser().parseFromString(String(text || ''), 'text/html').body.textContent || '';

  async function request(url, options = {}) {
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), 18000);
    try {
      const response = await fetch(url, { credentials: 'same-origin', ...options, signal: controller.signal });
      let data;
      try { data = await response.json(); } catch (_) { const error = new Error(messages.uncertain); error.uncertain = true; throw error; }
      if (!response.ok) { const error = new Error(typeof data.description === 'string' ? data.description : (typeof data.message === 'string' ? data.message : messages.error)); error.confirmedFailure = true; throw error; }
      return data;
    } catch (error) {
      if (!error.confirmedFailure) error.uncertain = true;
      throw error;
    } finally { clearTimeout(timer); }
  }

  function syncModalLock() { document.body.classList.toggle('modal-open', Boolean(document.querySelector('dialog[open]'))); }
  function openDialog(dialog) {
    if (!dialog || typeof dialog.showModal !== 'function') return false;
    if (!dialog.open) dialog.showModal();
    syncModalLock();
    return true;
  }
  function showError(container, message) {
    if (!container) return;
    container.textContent = message;
    container.hidden = false;
  }
  function installDrawer(markup, show = true) {
    if (typeof markup !== 'string' || !markup.trim()) return false;
    const parsed = new DOMParser().parseFromString(markup, 'text/html');
    const incoming = parsed.getElementById('CartDrawer');
    const existing = document.getElementById('CartDrawer');
    if (!incoming || !existing) return false;
    if (existing.open) existing.close();
    existing.replaceWith(incoming);
    const count = Number(incoming.dataset.count || 0);
    document.querySelectorAll('[data-cart-count]').forEach(node => { node.textContent = String(count); node.hidden = count === 0; });
    if (show && !openDialog(incoming)) return false;
    return true;
  }
  async function fetchDrawer(show = true) {
    const url = new URL(config.cart, location.origin);
    url.searchParams.set('section_id', 'cart-drawer');
    const preview = new URL(location.href).searchParams.get('preview_theme_id');
    if (preview) url.searchParams.set('preview_theme_id', preview);
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), 18000);
    try {
      const response = await fetch(url, {credentials:'same-origin',signal:controller.signal});
      if (!response.ok) throw new Error(messages.error);
      if (!installDrawer(await response.text(), show)) throw new Error(messages.error);
    } finally { clearTimeout(timer); }
  }

  function setDrawerBusy(value) {
    const drawer = document.getElementById('CartDrawer');
    if (!drawer) return;
    drawer.setAttribute('aria-busy', String(value));
    drawer.querySelectorAll('input,button').forEach(element => {
      if (!element.matches('[data-close-dialog]')) element.disabled = value;
    });
  }
  async function changeLine(key, quantity) {
    if (cartBusy || !key || !Number.isInteger(quantity) || quantity < 0) return;
    cartBusy = true; setDrawerBusy(true);
    try {
      const data = await request(api(config.change), { method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'}, body:JSON.stringify({id:key,quantity,sections:['cart-drawer'],sections_url:config.cart}) });
      if (!installDrawer(data.sections?.['cart-drawer'])) await fetchDrawer();
    } catch (error) {
      showError(document.querySelector('[data-drawer-error]'), error.uncertain ? messages.uncertain : error.message);
      announce(error.uncertain ? messages.uncertain : error.message);
    } finally { cartBusy = false; setDrawerBusy(false); }
  }

  function initGallery(gallery) {
    if (initializedGalleries.has(gallery)) return;
    initializedGalleries.add(gallery);
    const media = Array.from(gallery.querySelectorAll('[data-media-id]'));
    const thumbs = Array.from(gallery.querySelectorAll('[data-thumb]'));
    let current = Math.max(0, media.findIndex(node => !node.hidden));
    const show = index => {
      if (!media.length) return;
      current = (index + media.length) % media.length;
      media.forEach((node,i) => {
        node.hidden = i !== current;
        if (node.hidden) node.querySelectorAll('video').forEach(video => video.pause());
      });
      thumbs.forEach(node => { if (node.dataset.thumb === media[current].dataset.mediaId) node.setAttribute('aria-current','true'); else node.removeAttribute('aria-current'); });
      const position = gallery.querySelector('[data-gallery-position]');
      if (position) position.textContent = `${current + 1} / ${media.length}`;
      const zoomDialog=gallery.querySelector('[data-image-modal]');
      if(zoomDialog?.open){
        const zoomSource=media[current].querySelector('[data-zoom]');
        const zoomImage=zoomDialog.querySelector('[data-zoom-image]');
        if(zoomSource&&zoomImage){zoomImage.src=zoomSource.dataset.zoom;zoomImage.alt=zoomSource.dataset.alt||'';}
      }
    };
    gallery.addEventListener('xyra:media', event => {
      const index = media.findIndex(node => node.dataset.mediaId === String(event.detail));
      if (index >= 0) show(index);
    });
    const imageIndexes=media.map((node,i)=>node.querySelector('[data-zoom]')?i:-1).filter(i=>i>=0);
    gallery.querySelectorAll('[data-zoom-prev],[data-zoom-next]').forEach(button=>button.hidden=imageIndexes.length<2);
    function advanceZoom(delta){
      if(!imageIndexes.length)return;
      const position=imageIndexes.indexOf(current);
      show(imageIndexes[(position+delta+imageIndexes.length)%imageIndexes.length]);
    }
    gallery.addEventListener('click', event => {
      if(event.target.closest('[data-zoom-prev]')){advanceZoom(-1);return;}
      if(event.target.closest('[data-zoom-next]')){advanceZoom(1);return;}
      const thumb = event.target.closest('[data-thumb]');
      if (thumb) { event.preventDefault(); show(media.findIndex(node => node.dataset.mediaId === thumb.dataset.thumb)); }
      if (event.target.closest('[data-gallery-prev]')) show(current-1);
      if (event.target.closest('[data-gallery-next]')) show(current+1);
      const zoom = event.target.closest('[data-zoom]');
      if (zoom) {
        const dialog = gallery.querySelector('[data-image-modal]');
        const image = dialog?.querySelector('[data-zoom-image]');
        if (image) { image.src = zoom.dataset.zoom; image.alt = zoom.dataset.alt || ''; openDialog(dialog); }
      }
    });
    gallery.addEventListener('keydown',event=>{
      if(event.key!=='ArrowLeft' && event.key!=='ArrowRight')return;
      if(event.target.closest('video,iframe,model-viewer'))return;
      event.preventDefault();
      const step=event.key==='ArrowRight'?1:-1;
      if(gallery.querySelector('[data-image-modal]')?.open)advanceZoom(step);else show(current+step);
    });
    const stage = gallery.querySelector('.product-gallery__stage');
    let touchStart = null;
    stage?.addEventListener('touchstart', event => { if (event.touches.length === 1) touchStart = {x:event.touches[0].clientX,y:event.touches[0].clientY}; }, {passive:true});
    stage?.addEventListener('touchend', event => {
      const start=touchStart;touchStart=null;
      if (!start || !event.changedTouches.length || event.target.closest('video,iframe,button,model-viewer')) return;
      const dx = event.changedTouches[0].clientX-start.x;
      const dy = event.changedTouches[0].clientY-start.y;
      if (Math.abs(dx)>55 && Math.abs(dx)>Math.abs(dy)*1.3) show(current+(dx<0?1:-1));
    }, {passive:true});
    stage?.addEventListener('touchcancel',()=>{touchStart=null;},{passive:true});
    show(current);
  }

  function initProduct(form) {
    if (initializedProducts.has(form)) return;
    initializedProducts.add(form);
    const section = form.closest('[data-product-section]');
    const picker = form.querySelector('[data-variant-id]');
    const button = form.querySelector('[data-add-button]');
    const label = form.querySelector('[data-add-label]');
    const quantity = form.querySelector('input[name="quantity"]');
    const plan = form.querySelector('[data-selling-plan]');
    let variants;
    try { variants = JSON.parse(form.querySelector('[data-variants]').textContent); } catch (error) { console.error('XYRA variants:',error); return; }
    const getVariant = () => variants.find(variant => String(variant.id) === String(picker.value));
    function updateVariant(updateUrl = true) {
      const variant = getVariant();
      button.disabled = !variant?.available;
      label.textContent = variant ? (variant.available ? messages.add : messages.sold) : messages.unavailable;
      const availability = section.querySelector('[data-availability]');
      availability.replaceChildren();
      if (variant?.available) { const dot = document.createElement('span'); dot.className='availability-dot'; availability.append(dot); }
      availability.append(document.createTextNode(variant ? (variant.available ? messages.available : messages.sold) : messages.unavailable));
      if (!variant) return;
      if (quantity) {
        quantity.min = String(variant.min || 1); quantity.step = String(variant.step || 1);
        if (variant.max !== null && variant.max !== undefined) quantity.max=String(variant.max); else quantity.removeAttribute('max');
        let value = Math.max(Number(quantity.min), Number(quantity.value || quantity.min));
        if (variant.max !== null && variant.max !== undefined && variant.max >= Number(quantity.min)) value=Math.min(value,Number(variant.max));
        const step=Number(quantity.step)||1, minimum=Number(quantity.min)||1; quantity.value=String(minimum+Math.floor((value-minimum)/step)*step);
      }
      const priceNode = section.querySelector('[data-product-price]');
      const allocation = plan?.value ? variant.plans?.find(item => String(item.id) === plan.value) : null;
      if (plan?.value && !allocation) { button.disabled=true; label.textContent=messages.unavailable; }
      priceNode.replaceChildren();
      const price = document.createElement('span'); price.className='price__current';
      const displayAmount=allocation?.amount || variant.amount;
      if(displayAmount && variant.currency){
        const currency=document.createElement('span'); currency.className='price__currency';currency.textContent=variant.currency;
        const amount=document.createElement('span');amount.className='price__amount';amount.textContent=decodeText(displayAmount);
        price.append(currency,document.createTextNode(' '),amount);
      } else {price.textContent=decodeText(allocation?.price || variant.price);}
      priceNode.append(price);
      if (variant.compare && !allocation) { const old=document.createElement('s'); old.className='price__old'; old.textContent=decodeText(variant.compare); priceNode.append(old); }
      const sku=section.querySelector('[data-sku]'); if (sku) sku.textContent=variant.sku||'';
      if (variant.media) section.querySelector('[data-gallery]')?.dispatchEvent(new CustomEvent('xyra:media',{detail:variant.media}));
      if (updateUrl) { const url=new URL(location.href); url.searchParams.set('variant',String(variant.id)); if (plan?.value) url.searchParams.set('selling_plan',plan.value); else url.searchParams.delete('selling_plan'); history.replaceState({},'',url); }
      const error=form.querySelector('[data-product-error]'); if(error) error.hidden=true;
    }
    const requestedPlan=new URL(location.href).searchParams.get('selling_plan'); if(plan && requestedPlan && Array.from(plan.options).some(option=>option.value===requestedPlan))plan.value=requestedPlan;
    picker.addEventListener('change',()=>updateVariant());
    plan?.addEventListener('change',()=>updateVariant());
    updateVariant(false);
    form.addEventListener('submit',async event => {
      // With drawer disabled, the native product form posts directly to Shopify.
      if (!config.drawer || typeof HTMLDialogElement === 'undefined') return;
      event.preventDefault();
      if (cartBusy || form.dataset.busy === 'true' || !form.reportValidity() || button.disabled) return;
      const data=new FormData(form);
      data.set('sections','cart-drawer'); data.set('sections_url',config.cart);
      form.dataset.busy='true'; form.setAttribute('aria-busy','true'); cartBusy=true;
      cartReturnFocus=button; button.disabled=true; label.textContent=messages.adding;
      const errorNode=form.querySelector('[data-product-error]'); errorNode.hidden=true;
      try {
        const response=await request(api(config.add),{method:'POST',headers:{'Accept':'application/json'},body:data});
        if (!installDrawer(response.sections?.['cart-drawer'])) {
          try { await fetchDrawer(); } catch (_) { location.assign(config.cart); return; }
        }
        announce(messages.added);
      } catch(error) {
        const message=error.uncertain?messages.uncertain:error.message;
        showError(errorNode,message); announce(message);
        if(error.uncertain){ const link=document.createElement('a'); link.href=config.cart; link.textContent=` ${messages.viewCart || document.querySelector('[data-open-cart]')?.getAttribute('aria-label') || ''}`; link.style.textDecoration='underline'; errorNode.append(link); }
      } finally {
        form.dataset.busy='false'; form.removeAttribute('aria-busy'); cartBusy=false;
        const variant=getVariant(); const validPlan=!plan?.value || variant?.plans?.some(item=>String(item.id)===plan.value); button.disabled=!variant?.available || !validPlan; label.textContent=!validPlan?messages.unavailable:(variant?.available?messages.add:messages.sold);
      }
    });
  }

  // Measure content, not device models. Re-evaluate when the editor, menu or viewport changes.
  const layoutObserved = new WeakSet();
  let layoutFrame = 0;
  function updateResponsiveLayout() {
    layoutFrame = 0;
    const header = document.querySelector('[data-header]');
    const announcement = document.querySelector('.announcement');
    const headerHeight = Math.ceil(header?.getBoundingClientRect().height || 0);
    const totalHeight = headerHeight + Math.ceil(announcement?.getBoundingClientRect().height || 0);
    document.documentElement.style.setProperty('--header-height', `${headerHeight}px`);
    document.documentElement.style.setProperty('--header-total', `${totalHeight}px`);
    document.querySelectorAll('.product-info').forEach(panel => {
      // A tall purchase panel must scroll normally instead of trapping its bottom below the fold.
      panel.dataset.sticky = String(panel.offsetHeight + headerHeight + 48 < window.innerHeight);
    });
  }
  function queueResponsiveLayout() {
    if (!layoutFrame) layoutFrame = requestAnimationFrame(updateResponsiveLayout);
  }
  const layoutObserver = typeof ResizeObserver !== 'undefined' ? new ResizeObserver(queueResponsiveLayout) : null;
  function observeResponsiveLayout() {
    document.querySelectorAll('[data-header], .announcement, .product-info').forEach(node => {
      if (!layoutObserved.has(node)) { layoutObserved.add(node); layoutObserver?.observe(node); }
    });
    queueResponsiveLayout();
  }
  window.addEventListener('resize', queueResponsiveLayout, {passive:true});
  document.fonts?.ready.then(queueResponsiveLayout);

  function init(root = document) {
    observeResponsiveLayout();
    root.querySelectorAll('[data-gallery]').forEach(initGallery);
    root.querySelectorAll('[data-product-form]').forEach(initProduct);
  }
  document.addEventListener('click',async event => {
    const close=event.target.closest('[data-close-dialog]');
    if(close){ close.closest('dialog')?.close(); return; }
    const closeMenu=event.target.closest('[data-close-menu]');
    if(closeMenu){ const menu=closeMenu.closest('[data-menu]'); menu.open=false; menu.querySelector('summary').focus(); return; }
    const qtyButton=event.target.closest('[data-qty]');
    if(qtyButton){
      const input=qtyButton.closest('[data-quantity]').querySelector('input');
      if(input.disabled) return;
      const old=Number(input.value||input.min||1); const step=Number(input.step||1);
      let next=old+(qtyButton.dataset.qty==='plus'?step:-step);
      const min=Number(input.min||0); const max=input.max!==''?Number(input.max):Infinity;
      next=Math.min(max,Math.max(min,next));
      if(next===old){ if(next===max) announce(messages.limit); return; }
      input.value=String(next); input.dispatchEvent(new Event('change',{bubbles:true})); return;
    }
    const remove=event.target.closest('[data-remove-line]');
    if(remove){ event.preventDefault(); await changeLine(remove.dataset.removeLine,0); return; }
    const openCart=event.target.closest('[data-open-cart]');
    if(openCart && config.drawer && typeof HTMLDialogElement!=='undefined' && !event.metaKey && !event.ctrlKey && !event.shiftKey && event.button===0){
      event.preventDefault(); if(cartBusy)return; cartReturnFocus=openCart;
      openCart.setAttribute('aria-busy','true');
      try { await fetchDrawer(); } catch(_){ location.assign(config.cart); } finally { openCart.removeAttribute('aria-busy'); }
      return;
    }
    if(typeof HTMLDialogElement !== 'undefined' && event.target instanceof HTMLDialogElement){ const rect=event.target.getBoundingClientRect(); if(event.clientX<rect.left||event.clientX>rect.right||event.clientY<rect.top||event.clientY>rect.bottom)event.target.close(); }
    document.querySelectorAll('.nav-dropdown[open],.filter[open]').forEach(details=>{if(!details.contains(event.target))details.open=false;});
  });
  document.addEventListener('change',event=>{
    const input=event.target.closest('input[data-line-key]');
    if(input && input.checkValidity()) changeLine(input.dataset.lineKey,Number(input.value));
  });
  document.addEventListener('close',event=>{
    if(event.target.tagName!=='DIALOG')return;
    syncModalLock();
    if(event.target.id==='CartDrawer' && cartReturnFocus?.isConnected) cartReturnFocus.focus({preventScroll:true});
  },true);
  document.addEventListener('toggle',event=>{
    if(event.target.matches?.('[data-menu]'))document.body.classList.toggle('menu-open',event.target.open);
    if(event.target.matches?.('.nav-dropdown') && event.target.open){
      document.querySelectorAll('.desktop-nav .nav-dropdown[open]').forEach(other=>{if(other!==event.target && !other.contains(event.target))other.open=false;});
    }
  },true);
  document.addEventListener('keydown',event=>{
    const menu=document.querySelector('[data-menu][open]');
    if(event.key==='Escape'){
      document.querySelectorAll('.nav-dropdown[open],.filter[open]').forEach(node=>node.open=false);
      if(menu){menu.open=false;menu.querySelector('summary').focus();}
    }
    if(menu && event.key==='Tab'){
      const focusable=Array.from(menu.querySelectorAll('a,button,summary,input,select')).filter(node=>node.getClientRects().length && !node.disabled);
      const first=focusable[0],last=focusable[focusable.length-1];
      if(event.shiftKey && document.activeElement===first){event.preventDefault();last.focus();}
      else if(!event.shiftKey && document.activeElement===last){event.preventDefault();first.focus();}
    }
  });
  window.matchMedia('(min-width: 1400px)').addEventListener('change',event=>{if(event.matches){const menu=document.querySelector('[data-menu]');if(menu)menu.open=false;document.body.classList.remove('menu-open');}});
  document.addEventListener('shopify:section:load',event=>init(event.target));
  document.addEventListener('shopify:section:unload',()=>{queueResponsiveLayout();document.body.classList.remove('menu-open');syncModalLock();});

  // Keep old XYRA category links useful without fetching/rebuilding the catalogue in JavaScript.
  const oldUrl=new URL(location.href),oldCategory=oldUrl.searchParams.get('xyra_category');
  const categoryQueries={bags:'title:bag OR title:clutch OR title:bohina OR title:bucket OR title:"laptop sleeve"',hats:'title:hat OR title:hut',clothes:'title:bikini OR title:set OR title:jacke OR title:jacket OR title:kleid OR title:dress OR title:pareo',tote:'title:tote',mini:'title:mini',small:'title:small',medium:'title:medium',large:'title:large',clutch:'title:clutch',bucket:'title:bucket',basket:'title:basket',beach:'title:beach',boho:'title:boho',envelope:'title:envelove OR title:envelope',laptop:'title:laptop',galleria:'title:galleria',jackets:'title:jacke OR title:jacket',bikini:'title:bikini',sets:'title:set',special:'title:fragosyko OR title:nisiotissa OR title:fegarada OR title:anemi'};
  const modernCategories = {bags:'bags',hats:'hats',clothes:'clothing',summer:'summer',autumn:'autumn'};
  if(oldCategory && modernCategories[oldCategory]){
    oldUrl.pathname=config.root.replace(/\/$/,'')+'/collections/all';
    ['q','type','xyra_category','page','sort_by'].forEach(key=>oldUrl.searchParams.delete(key));
    oldUrl.searchParams.set('view','xyra-'+modernCategories[oldCategory]);
    location.replace(oldUrl.href);return;
  }
  if(oldCategory && categoryQueries[oldCategory]){
    oldUrl.pathname=config.search; oldUrl.searchParams.set('q',categoryQueries[oldCategory]);oldUrl.searchParams.set('type','product');oldUrl.searchParams.delete('xyra_category');oldUrl.searchParams.delete('page');
    if(!['price-ascending','price-descending','relevance'].includes(oldUrl.searchParams.get('sort_by')))oldUrl.searchParams.delete('sort_by');
    location.replace(oldUrl.href);return;
  }

  document.querySelectorAll('[data-address-country]').forEach(country=>{
    const form=country.closest('form'),province=form.querySelector('[data-address-province]'),container=form.querySelector('[data-province-container]');
    if(country.dataset.default)country.value=country.dataset.default;
    function provinces(initial){let values=[];try{values=JSON.parse(country.selectedOptions[0]?.dataset.provinces || '[]');}catch(_){} province.replaceChildren();values.forEach(([value,text])=>province.add(new Option(text,value)));container.hidden=values.length===0;province.disabled=values.length===0;if(initial && province.dataset.default)province.value=province.dataset.default;}
    country.addEventListener('change',()=>provinces(false));provinces(true);
  });
  init();
})();
